import classnames from 'classnames';
import { TFunction } from 'i18next';
import React from 'react';

import { ganttChartSeriesConfig } from './config';

type GanttChartYAxisLabelsProps = {
  isHidden: boolean;
  slug: string;
  t: TFunction;
};

export const GanttChartYAxisLabels: React.FC<GanttChartYAxisLabelsProps> = ({ slug, isHidden, t }) => (
  <div
    className={classnames(`${slug}__gantt-chart__y-axis-container`, {
      [`${slug}__gantt-chart__y-axis-container--hidden`]: isHidden,
    })}
    data-test-id={`${slug}-detail:gantt-chart-y-axis`}
  >
    {ganttChartSeriesConfig.map((seriesConfig) => (
      <span key={seriesConfig.id}>{t(seriesConfig.nameKey)}</span>
    ))}
  </div>
);
